// extracted by mini-css-extract-plugin
module.exports = {"app":"_3cl756BP8kssTYTEsON-Ao"};